import { Injectable } from '@angular/core';
import { HttpService } from '../core/http/http.service';
import { AuthenticationService } from '../_services/authentication/authentication.service';
import * as e from '../_entities';
import { IPatch } from '../core/i-patch';

@Injectable()
export class ApiService {

	constructor(
		private readonly auth: AuthenticationService,
		private readonly http: HttpService) { }

	store = {
		get: (storeId: number) => this.http.get<e.IStore>(`api/store/${storeId}`),
		patch: (storeId: number, patches: IPatch[]) => this.http.patch<e.IStore>(`/api/store/${storeId}`, patches),

		getOpeningHours: (storeId: number) => this.http.get<e.IStoreOpeningHours>(`api/store/${storeId}/openinghours`),
		setOpeningHour: (storeId: number, day: string, opensAt: string, closesAt: string) => this.http.put<e.IStoreOpeningHour>(`api/store/${storeId}/openinghours/${day}`, {opensAt: opensAt, closesAt: closesAt}),
		updateOpeningHourException: (id: number, storeId: number, date: string, reason: string, opensAt: string, closesAt: string) => this.http.put<e.IStoreOpeningHour>(`api/openinghourexceptions/${id}`, { id: id, storeid: storeId, date: date, opensAt: opensAt, closesAt: closesAt, reason: reason }),
		createOpeningHourException: (storeId: number, date: string) => this.http.post<e.IStoreOpeningHour>(`api/store/${storeId}/openinghourexceptions`, { date: date }),
		deleeteOpeningHourException: (id: number) => this.http.delete<e.IStoreOpeningHour>(`api/openinghourexceptions/${id}`),


		getBrands: () => this.http.get<e.IIdNameDescription[]>("api/support/brand"),
		getOperationTypes: () => this.http.get<e.IIdName[]>("api/support/operation"),
		getFormats: () => this.http.get<e.IIdNameDescription[]>("api/support/storeformat"),
	};

	addresses = {
		getForStore: (storeId: number) => this.http.get<e.IAddress[]>(`api/store/${storeId}/address`),
		addForStore: (storeId: number, address: e.IAddress) => this.http.post<e.IAddress>(`/api/store/${storeId}/address`, address),

		update: (address: e.IAddress) => this.http.put<e.IAddress>(`api/address/${address.id}`, address)
	};

	map = {
		getStores: () => this.http.get<e.IMapStore[]>("api/map/stores")
	};

	geography = {
		getCountries: () => this.http.get<e.ICountry[]>("api/support/country")
	};

	files = {
		patchStorePhoto: (id: number, data: any) => this.http.patch<e.IStorePhoto>(`api/storephoto/${id}`, data),
		patchStoreDrawing: (id: number, data: any) => this.http.patch<e.IStoreDrawing>(`api/storedrawing/${id}`, data),
		patchStoreDocument: (id: number, data: any) => this.http.patch<e.IStoreDocument>(`api/storedocument/${id}`, data),

		delete: (fileId: number) => this.http.delete(`api/file/${fileId}`)

	};

	projects = {
		get: (projectId: number) => this.http.get<e.IProjectDetails>(`api/project/${projectId}`),

		getStatuses: () => this.http.get<e.IIdName[]>("api/support/projectstatus"),
		getActions: () => this.http.get<e.IIdName[]>("api/support/projectaction"),
		getDeliverableTemplates: () => this.http.get<e.IIdName[]>("api/support/deliverabletemplate")

	}

	tags = {
		getPhotoTags: () => this.http.get<e.ITag[]>("api/support/tag/photo"),
		getDrawingTags: () => this.http.get<e.ITag[]>("api/support/tag/drawing"),
		getDocumentTags: () => this.http.get<e.ITag[]>("api/support/tag/document")
	};

	contracts = {
		getIfrsReport: (contractId: number) => this.http.get<any>(`api/contract/${contractId}/ifrsreport`),
		getIfrsReport2: (contractId: number) => this.http.get<any>(`api/contract/${contractId}/ifrsreport2`),
		getLandlords: () => this.http.get<e.IIdName[]>("api/support/supplier/landlord"),
		getStatuses: () => this.http.get<e.IIdName[]>("api/support/contractstatus"),

		getConsumerPriceIndexes: (countryCode: string) => this.http.get<any[]>(`api/support/consumerpriceindex?countryCode=${countryCode}`),
		patchConsumerPriceIndexes: (id: number, data: any) => this.http.patch<any>(`api/support/consumerpriceindex/${id}`, data),

		addIfrsReportRebate: (contractId: number, date: string) => this.http.post<any>(`api/contract/${contractId}/ifrsreportrebate`, { startDate: date }),
		updateIfrsReportRebate: (contractId: number, id: number, data: any) => this.http.put<any>(`api/contract/${contractId}/ifrsreportrebate/${id}`, data),
		deleteIfrsReportRebate: (contractId: number, id: number) => this.http.delete<any>(`api/contract/${contractId}/ifrsreportrebate/${id}`),
	};

	areaPlanner = {
		getConceptTemplates: () => this.http.get<e.IConceptTemplate[]>("api/support/concepttemplate")
	};

	reports = {
		getStoreInfo: (handler: string) => this.http.get<e.IReport>(`reports/storeinfo?handler=${handler}`)

	};

	audits = {
		getAudits: (entityType: string, entityId: string) => this.http.get<any>(`api/audit/${entityType}/${entityId}`)
	};

	users = {
		getAll: () => this.http.get<e.IUser[]>("api/user")
	};

	profile = {
		get: () => this.http.get<e.IUserProfile>(`api/user/${this.auth.authenticatedUser.name}/profile`).then(res => new e.UserProfile(res)),
		save: (value: e.UserProfile) => this.http.post<e.IUserProfile>(`api/user/${this.auth.authenticatedUser.name}/profile`, value).then(res => new e.UserProfile(res))
	};

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/api.service.ts